import { render, staticRenderFns } from "./PaymentModals.vue?vue&type=template&id=16598534&"
import script from "./PaymentModals.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaymentModals.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalPayByCheck: require('/usr/www/nuxt/components/Modal/ModalPayByCheck.vue').default,ModalCheckPrint: require('/usr/www/nuxt/components/Modal/ModalCheckPrint.vue').default})
